export default function(val, digits = 2) {
    return isNaN(val) || val === null || Number(val | 0.00 ) === 0.00 ? '' : Number(val).toLocaleString('pt-BR', { minimumFractionDigits: digits,  maximumFractionDigits: digits})
}